module.exports = __webpack_public_path__ + "static/media/icon_userprofile.d6c13e54.svg";